// import { async } from '@firebase/util';
// import React from 'react';
import { getMySubscription } from "../../api/api";
import React, { useEffect, useState } from "react";
import PlanExpiredDialog from "../subscription/PlanExpiredDialog";
import { useNavigate } from "react-router-dom";
import {
  BlueLinearGradient,
  BlueTextLinearGradient,
  isSubscriptionExpired,
  showInstructionDialog,
  WhiteLinearGradient,
} from "../../utils/Utils";
import { useAuthContext } from "../../context/AuthContext";
import { useAppContext } from "../../context/AppContext";

const BillingAfter = () => {
  let subscription;
  const [title, setTitle] = useState(" ");
  const [description, setDescription] = useState(" ");
  const [dateString, setDateString] = useState(" ");
  const [daysRem, setDaysRem] = useState(" ");
  const auth = useAuthContext();
  const appState = useAppContext();
  const [showPlanExpired, setShowPlanExpired] = useState(false);
  const [showInstruction, setShowInstruction] = useState(true);
  const navigate = useNavigate();

  const getSub = async () => {
    const sub = await getMySubscription();
    subscription = sub;
    setTitle(subscription.subscriptionTitle);
    setDescription(subscription.subscriptionDescription);
    setDateString(subscription.dateString);
    setDaysRem(subscription.exipiresIn);
  };

  useEffect(() => {
    getSub();
  }, []);

  return (
    <div className="bg-[#0E0E11] md:py-20 py-24">
      <div className=" flex flex-col justify-center">
        <p className="font-poppins text-primary-neonGreen font-bold text-3xl md:text-4xl leading-snug md:ml-16 ml-8">
          Your <span className=" text-white"> Plan</span>
        </p>
      </div>
      <div className="h-50 bg-[#24242D] text-white my-5 ml-7 md:ml-16 mr-7 md:mr-20 pb-5 rounded-md">
        <div className="grid grid-rows-1 md:grid-rows-2 gap-1 md:gap-2 p-10">
          <div className="grid md:grid-col-2 grid-col-1">
            <p className="col-start-1 text-white font-bold text-xl md:text-2xl">
              {title}
              <br />
              <span className="text-white text-xs md:text-sm">
                {dateString}
              </span>
            </p>
            <p className="flex md:justify-end md:col-start-2 col-start-1 mr-0 md:mr-4 text-[#FFEE54] font-bold text-sm md:text-lg">
              {
                // auth.state.user && isSubscriptionExpired(auth.state.user?.expiresAt)
                daysRem?.split(" ")[2] < 0 ? (
                  <p className="text-red-700 font-bold text-lg font-poppins">
                    Your plan is expired
                  </p>
                ) : (
                  daysRem
                )
              }
            </p>
          </div>
          <div className="grid grid-col-2 mt-10 md:mt-3 ml-1">
            <p className="col-start-1 text-white text-sm md:text-md text-opacity-80">
              {description}
              <br />
              <button
                className="text-white jutify-center rounded-sm bg-[#3E0CA7] mt-2 md:mt-4 py-4 px-5"
                onClick={() => {
                  navigate("/subscription");
                }}
              >
                Upgrade Membership
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingAfter;

// Auth
// {auth.state.user &&
//     isSubscriptionExpired(auth.state.user.expiresAt) ? (
//     <Button
//       type="primary"
//       onClick={() => {
//         setShowPlanExpired(true);
//       }}
//     >
//       Start
//     </Button>
//   ) : (
//     <Button
//       type="primary"
//       onClick={(e) => {
//         if (showInstructionDialog()) {
//           setPlayAudio(false);
//           setShowInstruction(true);
//         }
//       }}
//     >
//       {showInstructionDialog() ? (
//         "Start"
//       ) : (
//         <a href={`${playlist.playlistUrl}`} className={"self-end"}>
//           Start
//         </a>
//       )}
//     </Button>
//   )}
